import { render, staticRenderFns } from "./g-share.vue?vue&type=template&id=947cfb6e&scoped=true"
import script from "./g-share.vue?vue&type=script&lang=js"
export * from "./g-share.vue?vue&type=script&lang=js"
import style0 from "./g-share.vue?vue&type=style&index=0&id=947cfb6e&prod&lang=less&scoped=true"
import style1 from "./g-share.vue?vue&type=style&index=1&id=947cfb6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947cfb6e",
  null
  
)

export default component.exports